import React, { Component } from "react";

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import GridListTile from '@material-ui/core/GridListTile';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

import AssignmentCell from '../components/Assignment_Cell';
import * as AS from '../styles/Assignment_Styles';

import assignmentStore from '../stores/AssignmentStore';
import * as AA from '../actions/AssignmentActions';

const styles = theme => ({
    root: {
        textAlign: 'center',
    },
    title: {
        fontSize: '1.25rem'
    },
    center: {
        textAlign: 'center'
    }
});



class AssignmentDisplay extends Component {
    constructor(props) {
        super(props);

        this.getAsignStore = this.getAsignStore.bind(this);

        const { columns, ticketsDisplay, meta } = assignmentStore.getAll();

        this.state = {
            columns,
            ticketsDisplay,
            meta,
        };

    }

    // --- HOOKS ---

    componentDidMount() {
        AA.updateTickets();
        assignmentStore.on('change', this.getAsignStore);
    }


    componentWillUnmount() {
        assignmentStore.removeListener('change', this.getAsignStore);
    }

    // --- FLUX ---

    getAsignStore = () => {
        const { columns, ticketsDisplay, meta } = assignmentStore.getAll();
        this.setState({
            columns, 
            ticketsDisplay,
            meta
        })
    }


    // --- EVENTS ---


    // --- HELPERs ---

    type = (ticket) => {
        if (ticket.customerDefect) {
            return 'C.D.';
        } else if (ticket.quickWin) {
            return 'Q.W.';
        } else if (ticket.featureRequest) {
            return 'F.R.';
        } else {
            return '?';
        }
    }

    release = (ticket) => {
        if (ticket.release) {
            return 'X'
        } else {
            return '-'
        }
    }

    getCellStyle = (columnId) => {
        if(columnId === 'status') {
            return {
                width: '1%',
                padding: '0px 0px 0px 0px',
                textAlign: 'center',
            }

        } else if( columnId === 'number') {
            return {
                width: '5%',
                padding: '0px 0px 0px 0px',
                textAlign: 'center',
            }

        } else if( columnId === 'type') {
            return {
                width: '1%',
                padding: '0px 0px 0px 0px',
                textAlign: 'center',
            }

        }
    }

    // --- RENDER ---

    render() {
        window.cd = this.state;

        const { columns, ticketsDisplay } = this.state;
        const { classes } = this.props;

        if (this.state.meta.loading) {
            return (
                <div className={classes.center}>
                    <br/><br/><br/>
                    <CircularProgress
                        size={25}
                    ></CircularProgress>
                </div>
            )
        }

        return (
            <div>
                <br></br>
                <br></br>
                <div>
                    <Grid container spacing={8}>
                        {ticketsDisplay.map(assignee => (
                            <Grid item xs={'auto'} key={assignee.id}>
                                <GridListTile key={assignee.id} cols={assignee.cols || 1} rows={assignee.rows || 1}>
                                    <Card>
                                        <CardHeader
                                            styles={AS.getHeaderStyles()}
                                            title={assignee.id}
                                            classes={{ root: classes.root, title: classes.title }}
                                        ></CardHeader>
                                        <CardContent>

                                            <Table className={classes.table} aria-labelledby="tableTitle">
                                                <TableBody>
                                                    {assignee.tickets.map((ticket) => (
                                                        <TableRow
                                                            // hover
                                                            tabIndex={-1}
                                                            key={ticket.id}
                                                        >
                                                            {columns.map((column) => {
                                                                const id = `${ticket.id}${column.id}`
                                                                return (
                                                                    <AssignmentCell
                                                                        key={id}
                                                                        data={ticket}
                                                                        column={column.id}
                                                                    ></AssignmentCell>
                                                                )
                                                            })}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>

                                        </CardContent>
                                    </Card>
                                </GridListTile>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </div>
        );
    }
}

AssignmentDisplay.propTypes = {
};

export default withStyles(styles)(AssignmentDisplay);


// WEBPACK FOOTER //
// ./src/js/components/Assignment_Display.js